/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Mail_Type_NewsletterInputs */

const ja_playdata_mail_type_newsletter = /** @type {(inputs: Playdata_Mail_Type_NewsletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA メールマガジン登録`)
};

const en_playdata_mail_type_newsletter = /** @type {(inputs: Playdata_Mail_Type_NewsletterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA newsletter signup`)
};

/**
* | output |
* | --- |
* | "PLAYDATA newsletter signup" |
*
* @param {Playdata_Mail_Type_NewsletterInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_mail_type_newsletter = /** @type {((inputs?: Playdata_Mail_Type_NewsletterInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Mail_Type_NewsletterInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_mail_type_newsletter(inputs)
	return en_playdata_mail_type_newsletter(inputs)
});